import Grid from '@mui/material/Unstable_Grid2';
import { useTheme } from '@mui/material/styles';

import { Typography } from '@mui/material';
import {
  useGetPerformanceFilters,
  useGetPerformanceStats,
  useGetPeriodsStats,
  useGetPlansStats,
  useGetSalesOverTimeStats,
  useGetSubscriptionsOverTimeStats,
} from 'src/api/performance';
import { RoleBasedGuard } from 'src/auth/guard';
import { useAuthContext } from 'src/auth/hooks';
import PermissionBasedGuard from 'src/auth/guard/permission-based-guard';
import { hasPermissions } from 'src/auth/guard/utils';
import AnalyticsCurrentVisits from '../analytics-current-visits';
import EcommerceYearlySales from '../ecommerce-yearly-sales';
import PerformanceWidgetSummary from '../performance-widget-summary';

// ----------------------------------------------------------------------

export default function OverviewPerformanceView() {
  const { user } = useAuthContext();

  const {
    monthly_sales,
    monthly_income,
    active_subscriptions,
    total_subscriptions,
    performanceLoading,
    performanceError,
  } = useGetPerformanceStats();

  const { subsperplanData, subsperplanLoading, subsperplanError } = useGetPlansStats();

  const { subsperperiodData, subsperperiodLoading, subsperperiodError } = useGetPeriodsStats();

  const { subspertimeData, subspertimeLoading, subspertimeError } =
    useGetSubscriptionsOverTimeStats();

  const { salespertimeData, salespertimeLoading, salespertimeError } = useGetSalesOverTimeStats();

  const { filters, filtersLoading, filtersError } = useGetPerformanceFilters();

  const theme = useTheme();

  const isLoading =
    performanceLoading ||
    subsperplanLoading ||
    subsperperiodLoading ||
    subspertimeLoading ||
    salespertimeLoading ||
    filtersLoading;

  const isError =
    performanceError ||
    subsperplanError ||
    subsperperiodError ||
    subspertimeError ||
    salespertimeError ||
    filtersError;

    const canHandleMultipleRestaurants = hasPermissions(user, [
      'partners:misc:handle_multiple_restaurants',
    ]);

  return (
    <PermissionBasedGuard permissions={['partners:read:graphics']} hasContent>
      {
        // eslint-disable-next-line no-nested-ternary
        isLoading ? (
          <Typography variant="h5" sx={{ my: 3 }}>
            Loading...
          </Typography>
        ) : isError ? (
          <h6>Failed to load performance stats</h6>
        ) : (
          <Grid container spacing={3}>
            {monthly_sales && (
              <Grid xs={12} md={4}>
                <PerformanceWidgetSummary
                  title="Total Sales"
                  percent={0} // Default value since percent doesn't exist in the data structure
                  total={monthly_sales.total}
                  chart={{
                    series: monthly_sales.series,
                  }}
                />
              </Grid>
            )}

            {monthly_income && (
              <Grid xs={12} md={4}>
                <PerformanceWidgetSummary
                  title="Total Income"
                  percent={0} // Default value since percent doesn't exist in the data structure
                  total={monthly_income.total}
                  chart={{
                    colors: [theme.palette.info.light, theme.palette.info.main],
                    series: monthly_income.series,
                  }}
                />
              </Grid>
            )}

            {active_subscriptions && (
              <Grid xs={12} md={4}>
                <PerformanceWidgetSummary
                  title="Active Subscriptions"
                  percent={0} // Default value since percent doesn't exist in the data structure
                  total={active_subscriptions.total}
                  chart={{
                    colors: [theme.palette.warning.light, theme.palette.warning.main],
                    series: active_subscriptions.series,
                  }}
                />
              </Grid>
            )}

            {total_subscriptions && (
              <Grid xs={12} md={4}>
                <PerformanceWidgetSummary
                  title="Total Subscriptions"
                  percent={0} // Default value since percent doesn't exist in the data structure
                  total={total_subscriptions.total}
                  chart={{
                    colors: [theme.palette.warning.light, theme.palette.warning.main],
                    series: total_subscriptions.series,
                  }}
                />
              </Grid>
            )}

            <Grid xs={12} md={12} lg={12} />

            <Grid xs={12} md={12} lg={6}>
              <EcommerceYearlySales
                title="Subscriptions"
                subheader=""
                filterKey={filters}
                chart={subspertimeData}
              />
            </Grid>

            <Grid xs={12} md={12} lg={6}>
              <EcommerceYearlySales
                filterKey={filters}
                title="Sales"
                subheader=""
                chart={salespertimeData}
              />
            </Grid>

            <Grid xs={12} md={12} lg={12}>
              <AnalyticsCurrentVisits
                title="Subscriptions Period"
                chart={{
                  series: subsperperiodData.map((stat: { label: any; value: number }) => ({
                    label: stat.label,
                    value: stat.value,
                  })),
                }}
              />
            </Grid>

            <Grid xs={12} md={12} lg={12}>
              <AnalyticsCurrentVisits
                title="Plans Subscriptions"
                chart={{
                  series: subsperplanData.map(stat => ({
                    label: stat.label,
                    value: stat.value,
                  })),
                }}
              />
            </Grid>


            {/* <Grid xs={12} md={12} lg={12}>
              <EcommerceYearlySales
                filterKey={filters.all_plans}
                title="Plans Subscriptions/Sales"
                subheader=""
                chart={{
                  categories: subssalesovertimeData.labels,
                  series: [
                    {
                      year: 'last 12 months',
                      data: [
                        {
                          name: 'Sales',
                          data: subssalesovertimeData.data.sales,
                        },
                        {
                          name: 'Subscriptions',
                          data: subssalesovertimeData.data.subscriptions,
                        },
                      ],
                    },
                  ],
                }}
              />
            </Grid> */}
          </Grid>
        )
      }
    </PermissionBasedGuard>
  );
}
